<div
  class="car-card position-relative d-flex flex-column justify-content-center align-items-center"
  [style.height.px]="height"
>
  <!-- Overlay should be an empty element -->
  <div class="car-card-overlay"></div>

  <div class="featured-tag" *ngIf="car.featured">
    <span class="ff-poppins-medium">Featured</span>
  </div>

  <div class="d-flex flex-column mb-3 position-absolute card-header">
    <div class="hot-deal-tag d-flex align-items-center mb-2" *ngIf="car.hotDeal">
      <span class="ff-poppins-semibold">
        <img src="/icons/ic_hot_deal.svg" alt="hot deal" /> Hot Deal</span
      >
    </div>
    <p class="car-name ff-poppins-semibold m-0">{{ car.name }}</p>
    <p class="car-name ff-poppins-semibold m-0 py-1" style="font-size: 1rem">(or Similar)</p>
    <p *ngIf="selectedPrice" class="car-price ff-poppins-semibold m-0">
      <span class="amount ff-poppins-semibold">
        {{ getDiscountedPrice(+selectedPrice) | currency: 'QAR ' : 'symbol' : '1.0-0' }}
      </span>
      <!-- <span class="per ff-poppins"> / </span> -->
      <span class="per ff-poppins">
        <ng-container [ngSwitch]="selectedSubscription">
          <span *ngSwitchCase="'per_minute'">Per Minute</span>
          <span *ngSwitchCase="'hourly'">Per Hour</span>
          <span *ngSwitchCase="'daily'">Per Day</span>
          <span *ngSwitchCase="'per_week'">Per Week</span>
          <span *ngSwitchCase="'per_month'">Per Month</span>
          <span *ngSwitchDefault>Per Day</span>
        </ng-container>
      </span>
      <span
        class="amount ff-poppins-semibold text-decoration-line-through align-top ms-2"
        style="font-size: 16px"
        *ngIf="car.hotDeal"
      >
        {{ selectedPrice | currency: 'QAR ' : 'symbol' : '1.0-0' }}
      </span>
    </p>
    <div class="d-flex w-100 car-details-row mt-2 overflow-x-auto overflow-y-hidden">
      <div class="detail-item">
        <img src="/icons/ic_car_seat.svg" alt="seats icon" class="me-1" />
        {{ car.seats }}&nbsp;
        <span class="detail-label">Seats</span>
      </div>
      <div class="detail-item">
        <img src="/icons/ic_car_engine_updated.svg" alt="engine icon" class="me-1" />
        {{ car.mileage }}L&nbsp;
        <span class="detail-label">Engine</span>
      </div>
      <div class="detail-item">
        <img src="/icons/ic_car_gear.svg" alt="automatic icon" class="me-1" />
        <span class="detail-label">{{ car.transmission | titlecase }}</span>
      </div>
    </div>
  </div>

  <div class="car-image-container position-absolute">
    <img
      [src]="images.length ? images[currentImageIndex] : avatar"
      [alt]="car.name"
      class="car-image"
      appAutoCrop
      [cropThreshold]="70"
    />

    <!-- <button *ngIf="images.length > 1" class="slider-arrow left" (click)="prevImage()" aria-label="Previous image">
      &#8592;
    </button>
    <button *ngIf="images.length > 1" class="slider-arrow right" (click)="nextImage()" aria-label="Next image">
      &#8594;
    </button> -->

    <!-- <div *ngIf="images.length > 1" class="slider-dots">
      <span *ngFor="let img of images; let i = index"
            [class.active]="i === currentImageIndex"
            (click)="selectImage(i)"></span>
    </div> -->
  </div>

  <div
    class="d-flex justify-content-between align-items-start mb-4 pb-2 car-info overflow-x-auto overflow-y-hidden"
  >
    <!-- Per Minute -->
    <div
      class="d-flex flex-column align-items-center price-item px-2"
      *ngIf="car.perMinuteRate && +car.perMinuteRate > 0"
    >
      <p class="ff-poppins-semibold m-0">
        {{ getDiscountedPrice(+car.perMinuteRate) | number: '1.0-0' }} QAR
      </p>
      <div class="rate-label">Per Minute</div>
    </div>

    <!-- Divider between minute → hour -->
    <div
      class="divider"
      *ngIf="car.perMinuteRate && +car.perMinuteRate > 0 && car.hourlyRate && +car.hourlyRate > 0"
    ></div>

    <!-- Per Hour -->
    <div
      class="d-flex flex-column align-items-center price-item px-2"
      *ngIf="car.hourlyRate && +car.hourlyRate > 0"
    >
      <p class="ff-poppins-semibold m-0">
        {{ getDiscountedPrice(+car.hourlyRate) | number: '1.0-0' }} QAR
      </p>
      <div class="rate-label">Per Hour</div>
    </div>

    <!-- Divider between hour → week -->
    <div
      class="divider"
      *ngIf="car.hourlyRate && +car.hourlyRate > 0 && car.weeklyRate && +car.weeklyRate > 0"
    ></div>

    <!-- Per Week -->
    <div
      class="d-flex flex-column align-items-center price-item px-2"
      *ngIf="car.weeklyRate && +car.weeklyRate > 0"
    >
      <p class="ff-poppins-semibold m-0">
        {{ getDiscountedPrice(+car.weeklyRate) | number: '1.0-0' }} QAR
      </p>
      <div class="rate-label">Per Week</div>
    </div>

    <!-- Divider between week → month -->
    <div
      class="divider"
      *ngIf="car.weeklyRate && +car.weeklyRate > 0 && car.monthlyRate && +car.monthlyRate > 0"
    ></div>

    <!-- Per Month -->
    <div
      class="d-flex flex-column align-items-center price-item px-2"
      *ngIf="car.monthlyRate && +car.monthlyRate > 0"
    >
      <p class="ff-poppins-semibold m-0">
        {{ getDiscountedPrice(+car.monthlyRate) | number: '1.0-0' }} QAR
      </p>
      <div class="rate-label">Per Month</div>
    </div>
  </div>
</div>
